import { cn } from "@/lib/cn";
import { type CSSProperties, type ReactNode, forwardRef } from "react";

export type KickerVariant = "cyan" | "magenta" | "muted";

export interface KickerProps {
  children: ReactNode;
  /** Color variant: cyan (default), magenta, or muted */
  variant?: KickerVariant;
  className?: string;
  style?: CSSProperties;
}

const VARIANT_CLASS: Record<KickerVariant, string> = {
  cyan: "",
  magenta: "iris-kicker--magenta",
  muted: "iris-kicker--muted",
};

/**
 * Section header kicker: UPPERCASE, neon glow, tracked letterforms.
 * Uses iris-kicker CSS classes from the token layer.
 */
export const Kicker = forwardRef<HTMLDivElement, KickerProps>(
  ({ children, variant = "cyan", className, style }, ref) => {
    return (
      <div ref={ref} className={cn("iris-kicker", VARIANT_CLASS[variant], className)} style={style}>
        {children}
      </div>
    );
  },
);
Kicker.displayName = "Kicker";
